import React from 'react'
import { Modal } from '@components/ui'

type ChartingUnsavedChangesModalProps = {
  show: boolean
  onKeepEditing: () => void
  onDiscard: () => void
}

const ChartingUnsavedChangesModal: React.FC<
  ChartingUnsavedChangesModalProps
> = ({ show, onKeepEditing, onDiscard }) => (
  <Modal
    open={show}
    onClose={onKeepEditing}
    size="xs"
    title="Unsaved changes"
    description="You have unsaved changes."
    primaryLabel="Discard"
    secondaryLabel="Keep editing"
    primaryDestructive
    onPrimaryClick={onDiscard}
    onSecondaryClick={onKeepEditing}
  />
)

export default ChartingUnsavedChangesModal
